<form
    [formGroup]="form"
>
    <div class="vstack gap-3">
        <div class="vstack gap-1">
            <label
                for="amount"
                class="form-label m-0 fw-semibold"
            >
                Amount
            </label>
            <div class="vstack gap-1">
                <div class="hstack gap-2">
                    <div class="input-group">
                        <span class="input-group-text">£</span>
                        <input
                            type="number"
                            step="1"
                            class="form-control"
                            formControlName="amount"
                            placeholder="0.00 - No Charge"
                            [ngClass]="{'is-invalid': form.get('amount')?.invalid && (form.get('amount')?.touched || form.get('amount')?.dirty)}"
                        />
                    </div>
                    @if (!amountOnly) {
                        <div
                            class="d-flex btn-group segmented-control justify-content-evenly"
                            role="group"
                        >
                            <input
                                type="radio"
                                class="btn-check"
                                id="perCover"
                                autocomplete="off"
                                [value]="true"
                                formControlName="isPerCover"
                            >
                            <label
                                class="btn btn-outline-primary text-nowrap"
                                for="perCover"
                                (click)="form.get('isPerCover')?.setValue(true)"
                            >
                                Per Cover
                            </label>
                            <input
                                type="radio"
                                class="btn-check"
                                id="perParty"
                                autocomplete="off"
                                [value]="false"
                                formControlName="isPerCover"
                            >
                            <label
                                class="btn btn-outline-primary text-nowrap"
                                for="perParty"
                                (click)="form.get('isPerCover')?.setValue(false)"
                            >
                                Flat Rate
                            </label>
                        </div>
                    }
                </div>
                <div
                    class="text-danger"
                    *ngIf="form.get('amount')?.errors?.['required'] && (form.get('amount')?.touched || form.get('amount')?.dirty)"
                >
                    Amount is required
                </div>
                <div
                    class="text-danger"
                    *ngIf="form.get('amount')?.errors?.['min'] && (form.get('amount')?.touched || form.get('amount')?.dirty)"
                >
                    Amount must be at least {{ form.get('amount')?.errors?.['min'].min | currency : currencyCode }}
                </div>
                <span class="form-text">
                    @if (this.form.get('chargeType')?.value === 'cancellationCharge') {
                        The amount the customer could be charged
                            if you decide to charge them for cancelling / not showing up.
                    } @else if (this.form.get('chargeType')?.value === 'depositCharge') {
                        The amount to charge for securing the booking.
                    }
                </span>
            </div>
        </div>
        <ng-content select="[charge-summary]"></ng-content>
        @if (form.get('expiryMinutes') !== null && showExpiryTime) {
            <div class="vstack gap-2">
                <label
                    for="expiryMinutes"
                    class="form-label m-0 fw-semibold"
                >
                    Expiry Time
                </label>
                @if (!form.get('isCustomExpiry')?.value) {
                    <select
                        class="form-select"
                        formControlName="expiryMinutes"
                        data-testid="expiry-minutes-select"
                    >
                        @if (previousExpiryDate) {
                            <option
                                [ngValue]="-1"
                            >
                                Don't Change - Booking will be cancelled at {{ previousExpiryDate | date: 'short' }}
                            </option>
                        }
                        @for (minutes of addPaymentExpiryOptions; track minutes) {
                            @if (minutes === null) {
                                <option
                                    [ngValue]="null"
                                >
                                    Never Expires
                                </option>
                            } @else {
                                <option
                                    [ngValue]="minutes"
                                >
                                    If not paid, booking will be cancelled {{ minutes | duration : DurationUnit.Minute | titlecase }}
                                    from now
                                </option>
                            }
                        }
                        <option value="custom">Other...</option>
                    </select>
                } @else {
                    <div class="hstack gap-2">
                        <input
                            type="number"
                            class="form-control"
                            formControlName="customExpiryValue"
                            placeholder="Amount"
                            min="1"
                            data-testid="custom-expiry-value"
                        />
                        <select
                            class="form-select"
                            formControlName="customExpiryUnit"
                            style="max-width: 150px;"
                            data-testid="custom-expiry-unit"
                        >
                            <option value="hours">Hours</option>
                            <option value="days">Days</option>
                            <option value="weeks">Weeks</option>
                        </select>
                        <button
                            type="button"
                            class="btn btn-outline-secondary"
                            (click)="cancelCustomExpiry()"
                        >
                            Cancel
                        </button>
                    </div>
                }
                <span class="form-text">
                    How long the link will be valid for before it expires and the booking is cancelled.
                </span>
            </div>
        }
    </div>
</form>
